import keyMirror from 'keymirror';

export const doubleTabsModalActionTypes = keyMirror({
	TOGGLE_DOUBLE_TABS_MODAL: null,
});
